<template>
  <card>
    <div slot="header">
      <h4 class="title">Card Setup</h4>
    </div>

    <div v-if="!card.status">
      <!-- <i class="fas fa-info-circle text-succ"/>-->  Once you've received your card, enter the 13 digits number found <u>on the back</u> of the card, at the bottom<br>
    </div>
    
    <br>
    <br>
    
    <div class="row">
      <div class="col-md-6">
        <fg-input type="text"
                  label="card proxy number"
                  :disabled="!!card.status"
                  placeholder="13 digits number"
                  v-model="card.id"
                  @keyup.enter="save()"
                  v-tooltip.top-center="card.status ? `You can't change your card number after it's been linked. For any assistance, please contact our Support team.` : ``">
        </fg-input>
      </div>
      <div v-if="card.status == 'active'" class="col-md-3 mt-4">
        <button width="10" class="btn btn-primary" @click="getPin()">Get PIN</button>
      </div>
    </div>

    <br>
    <div v-if="card.status">
      <label>
        Card status:
      </label>
      <template v-if="card.status == 'active'">
        &nbsp;&nbsp;&nbsp; Active &nbsp; <i class="fas fa-circle text-success"/>
      </template>
      <template v-if="card.status == 'inactive'">
        &nbsp;&nbsp;&nbsp; Inactive &nbsp; <i class="fas fa-circle text-warning"/>
      </template>
      <template v-if="card.status == 'expired'">
        &nbsp;&nbsp;&nbsp; Expired &nbsp; <i class="fas fa-circle text-danger"/>
      </template>
      <br><br>
    </div>


    <br>
    <div v-if="true && card.status == 'active'">
      <label>
        Activation date:
      </label>
      &nbsp;&nbsp;&nbsp;{{ dateToString(card.dateActivated) || '-' }}
      <br><br>
      <label>
        Expiration date:
      </label>
      &nbsp;&nbsp;&nbsp;{{ dateToString(card.dateExpiration) || '-' }}
      <br><br>
    </div>

    <br>
    <br>

    <div class="text-center">
      <button type="submit"
              :disabled="!!card.status"
              class="btn btn-info btn-fill btn-wd"
              @click.prevent="save">
        Save
      </button>
    </div>

  </card>
</template>

<script>
import utils from '../../utils'
import Card from '../Cards/Card.vue'
export default {
  components: { Card },
  name: 'Payment-Card-Setup',
  data () {
    return {
      card: {
        paymentCardProviderId: this.$store.getters.paymentCard.paymentCardProviderId,
        id: this.$store.getters.paymentCard.id,
        status: this.$store.getters.paymentCard.status,
        // status: 'active',
        dateActivated: this.$store.getters.paymentCard.dateActivated,
        dateExpiration: this.$store.getters.paymentCard.dateExpiration
      }
    }
  },
  methods: {
    async save () {
      const id = this.card.id
      if (!id || !Number(id) || id.length != 13) {
        this.$notify({ errorMessage: `Card number must be 13 digits longs` })
      }
      else {
        const res = await this.$store.dispatch('claimPaymentCard', { paymentCardProviderId: 1, id: this.card.id })
        if (res.errors) {
          if (!res.errors[0].toLowerCase().includes('session')) { // we don't show the error because the API service is rerouting to login page
            this.$notify({ errorMessage: res.errors[0] })
          }
        }
        else {
          this.$notify({ successMessage: 'Your card has been successfully activated!', timeout: 10000 })
          await this.$store.dispatch('fetchBaseData')
          this.card = this.$store.getters.paymentCard
        }
      }
    },
    dateToString(date) {
      return utils.dateToString(date)
    },
    async getPin() {
      const res = await this.$store.dispatch('getPaymentCardPin', this.card)
        if (res.errors) {
          if (!res.errors[0].toLowerCase().includes('session')) { // we don't show the error because the API service is rerouting to login page
            this.$notify({ errorMessage: res.errors[0] })
          }
        }
        else {
          this.$notify({ infoMessage: res || 'N/A', timeout: 10000 })
        }
    }
  }

}
</script>

<style>

</style>